// extracted by mini-css-extract-plugin
module.exports = {"link":"AuthNavigations_link__3csHL","active":"AuthNavigations_active__g7tGi"};